<template>
	<div class="container">
		<div class="allbox">
			<div class="box">
				<div class="title" style="display: none;">六神口红旗舰店</div>
				<div class="tab">
					<div class="title">发票类型</div>
					<ul class="tab_button">
						<li v-for="(item,index) in tabList" :key="index" :class="{active:currentClass==index}" @click="toggleTab(index,item)">{{item.title}}</li>
					</ul>
				</div>
			</div>
			<div class="tab_con tabone" v-show="currentTab==1">
				<p>电子发票即电子增值税发票，是税局认可的有效凭证，其法律效力、基本用途及使用规定同纸质发票。</p>
				<div class="tab_ge"></div>
				<div class="tab_kong">
					<van-cell-group>
						<van-field v-model="invoiceContent" label="*发票内容" placeholder=""  class="field"/>
					</van-cell-group>
					<div class="invoice">
						<span>*发票抬头</span>
						<ul class="tab_buttons">
							<li v-for="(items,index) in tabLists" :key="index" :class="{active:currentClasses==index}" @click="toggleTabs(index)">{{items}}</li>
						</ul>
					</div>
				</div>

				<div>
					<div class="tab_cons" v-show="currentTabs==0">
						<van-cell-group >
							<van-field v-model="myInvoice.name" label="*个人名称" placeholder="请输入个人名称"  class="field"/>
						</van-cell-group>
						<van-cell-group>
							<van-field v-model="myInvoice.email" label="*收票人邮箱" placeholder="请输入收票人邮箱" class="field"/>
						</van-cell-group>
					</div>
					<div class="tab_cons" v-show="currentTabs==1">
						<van-cell-group>
							<van-field v-model="comInvoice.name" label="*单位名称" placeholder="请输入发票抬头" class="field"/>
						</van-cell-group>
						<van-cell-group>
							<van-field v-model="comInvoice.no" label="*纳税人识别号" placeholder="请在此填写纳税人识别号" class="field"/>
						</van-cell-group>
						<van-cell-group>
							<van-field v-model="comInvoice.email" label="*收票人邮箱" placeholder="请输入收票人邮箱" class="field"/>
						</van-cell-group>
					</div>
				</div>
				<div class="notice">
					<div class="btn" @click="saveOrderInvoice">保存</div>
					<div class="noticetext">
						<p>发票须知：</p>
						<span>1.开票金额为用户实际支付金额(不含礼品卡)</span><br />
						<span>2.电子发票可在确认收货后，在“订单详情“查看</span><br />
						<span>3.未随箱寄出的纸质发票会在发货后15-30个工作日单独寄出</span><br />
						<span>4.单笔订单只支持开具一种发票类型，如需增值税专用发票请联系客服处理</span><br />
						<span>5.年购订单发票随每期子单寄出</span><br />
					</div>
				</div>


			</div>
			<div class="tab_con tabtwo" v-show="currentTab==2">
				<p>电子发票即电子增值税发票，是税局认可的有效凭证，其法律效力、基本用途及使用规定同纸质发票。</p>
				<div class="tab_ge"></div>
				<div class="tab_kong">
					<div class="invoice">
						<span>*发票抬头</span>
						<ul class="tab_buttons">
							<li v-for="(items,index) in tabLists" :key="index" :class="{active:currentClasses==index}" @click="toggleTabs(index)">{{items}}</li>
						</ul>
					</div>
					<van-cell-group>
						<van-field v-model="invoiceContent" label="*发票内容" placeholder="商品明细"  class="field"/>
					</van-cell-group>

				</div>

				<div>
					<div class="tab_cons" v-show="currentTabs==0">

						<van-cell-group >
							<van-field v-model="myInvoice.name" label="*个人名称" placeholder="请输入个人名称" class="field"/>
						</van-cell-group>

					</div>
					<div class="tab_cons" v-show="currentTabs==1">
						<van-cell-group>
							<van-field v-model="comInvoice.name" label="*单位名称" placeholder="请输入发票抬头" class="field"/>
						</van-cell-group>
						<van-cell-group>
							<van-field v-model="comInvoice.no" label="*纳税人识别号" placeholder="请在此填写纳税人识别号" class="field" />
						</van-cell-group>
					</div>
				</div>
				<div class="notice">
					<div class="btn" @click="saveOrderInvoice">保存</div>
					<div class="noticetext">
						<p>发票须知：</p>
						<span>1.开票金额为用户实际支付金额(不含礼品卡)</span><br />
						<span>2.电子发票可在确认收货后，在“订单详情“查看</span><br />
						<span>3.未随箱寄出的纸质发票会在发货后15-30个工作日单独寄出</span><br />
						<span>4.单笔订单只支持开具一种发票类型，如需增值税专用发票请联系客服处理</span><br />
						<span>5.年购订单发票随每期子单寄出</span><br />
					</div>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
import {saveOrderInvoice} from "../../../api/api";
import wx from 'weixin-js-sdk'
	export default {
		name: 'Home',
		props: {},
		data() {
			return {
				value: '',
				currentTab: 0,
				currentClass: 0,
				currentTabs: 0,
				currentClasses: 0,
				tabList: [{id:0,title:'无需发票'},{id:1,title:'电子发票'},{id:2,title:'纸质发票'}],
				tabLists: ['个人', '单位'],
				goodsId:this.$route.query.goodsId,
				goodsNum:this.$route.query.goodsNum,
				invoiceId:null,
				invoiceType:0,
				addressId:this.$route.query.addressId,
				myInvoice:{},
				invoiceContent:'',
				comInvoice:{}

			};
		},
		methods: {
			toggleTab(current,item) {
				this.currentTab = current;
				this.currentClass = current;
				this.invoiceId=item.id;
				this.invoiceType=item.id;
			},
			toggleTabs(currents) {
				this.currentTabs = currents;
				this.currentClasses = currents;
			},
			backChange(){
				wx.miniProgram.navigateTo({
					url: '/pages/submitOrder/submitOrder?goodsId='+this.goodsId+'&goodsNum='+this.goodsNum+'&addressId='+this.addressId+'&invoiceType='+this.invoiceType
				})
			},
			async saveOrderInvoice(){
				var param={};
				if(this.currentTab==1){
					//电子发票
					param.invoiceWay=1;
					param.invoiceContent=this.invoiceContent;
					if(this.currentTabs==0){
						//个人
						param.invoiceType=1;
						param.invoiceReceiverName=this.myInvoice.name;
						param.invoiceEmail=this.myInvoice.email;
						if (!this.myInvoice.name) {
							this.$toast("请输入发票抬头~");
							return;
						}
						if (!this.myInvoice.email) {
							this.$toast("请输入邮箱~");
							return;
						}
						var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
						if (!reg.test(this.myInvoice.email)) {
							this.$toast('请输入正确的邮箱地址~');
							return
						}
					}else{
						//单位
						param.invoiceType=2;
						param.invoiceReceiverName=this.comInvoice.name
						param.invoiceEmail=this.comInvoice.email;
						param.invoiceTaxId=this.comInvoice.no;
						if (!this.comInvoice.name) {
							this.$toast("请输入名称");
							return;
						}
						if (!this.comInvoice.no) {
							this.$toast("请输入纳税人识别码~");
							return;
						}
						if (!this.comInvoice.email) {
							this.$toast("请输入邮箱~");
							return;
						}
						var regs = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
						if (!regs.test(this.comInvoice.email)) {
							this.$toast('请输入正确的邮箱地址~');
							return
						}
					}
					if (!this.invoiceContent) {
						this.$toast("请输入内容");
						return;
					}
				}else if(this.currentTab==2){
					param.invoiceWay=2;
					param.invoiceContent=this.invoiceContent;
					if(this.currentTabs==0){
						//个人
						param.invoiceType=1;
						param.invoiceReceiverName=this.myInvoice.name;
						if (!this.myInvoice.name) {
							this.$toast("请输入名称");
							return;
						}
					}else{
						//单位
						//单位
						param.invoiceType=2;
						param.invoiceReceiverName=this.comInvoice.name;
						param.invoiceTaxId=this.comInvoice.no;
						if (!this.comInvoice.name) {
							this.$toast("请输入名称");
							return;
						}
						if (!this.comInvoice.no) {
							this.$toast("请输入纳税人识别码~");
							return;
						}
					}
					if (!this.invoiceContent) {
						this.$toast("请输入内容");
						return;
					}
				}
				const res = await saveOrderInvoice(param);
				if (res.code === "0000") {
					wx.miniProgram.navigateTo({
						url: '/pages/submitOrder/submitOrder?invoiceId='+res.data+'&goodsId='+this.goodsId+'&goodsNum='+this.goodsNum+'&addressId='+this.addressId+'&invoiceType='+this.invoiceType
					})
				} else {
					this.$toast(res.msg);
				}
			},
		},
		mounted: function(options) {
			// 如果支持 popstate 一般移动端都支持了
			// if (window.history && window.history.pushState) {
			// 	// 往历史记录里面添加一条新的当前页面的url
			// 	history.pushState(null, null, document.URL);
			// 	// 给 popstate 绑定一个方法 监听页面刷新
			// 	window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
			// }
		},
		// destroyed(){
		// 	window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
		// },
	}
</script>
<style scoped lang="scss">
	.container {

		// background-color: #f7f7f7;
		.allbox {
			background: #fff;

			.box {
				padding: 30px 20px 0 20px;
			}

			.tab {
				height: 162px;
			}

			.title {
				height: 1rem;
				line-height: 2em;
				font-size: 26px;
				color: #333333;
			}

			.tab_button li {
				width: 180px;
				height: 50px;
				background: #F5F6F5;
				cursor: pointer;
				margin-right: 20px;
				display: inline-block;
				border-radius: 20px;
				font: 24px/50px 'Microsoft Yahei';
				color: #999999;
				text-align: center;
			}

			.tab_button li.active {
				border: 1px solid #f3ae19;
				background-color: #DC242F;
				color: #fff;
			}

			.tab_con {
				// padding: 20px 0;
			}

			.tabone,
			.tabtwo {
				.tab_ge {
					width: 100%;
					height: 20px;
					background-color: #f7f7f7;
				}

				p {
					font-size: 20px;
					padding: 0 20px 20px 20px;
				}

				.invoice {
					height: 80px;
					display: flex;
					align-items: center;

					span {
						padding-left: 20px;
						font-size: 26px !important;
						padding-right: 100px;
					}
				}

				.tab_buttons li {
					width: 119px;
					height: 50px;
					background: #F5F6F5;
					cursor: pointer;
					margin-right: 20px;
					display: inline-block;
					border-radius: 20px;
					font: 24px/50px 'Microsoft Yahei';
					color: gray;
					text-align: center;
				}

				.tab_buttons li.active {
					border: 1px solid #f3ae19;
					background-color: #DC242F;
					color: #fff;
				}

				.tab_cons,
				.tab_kong {

				}

				p {
					color: #999999;
				}
			}

			.tabtwo {
				.invoice {
					span {
						font-size: 26px !important;
						padding-right: 100px;
					}
				}
			}
		}

		.notice {
			padding-top: 50px;
			background-color: #f7f7f7;

			.btn {
				width: 580px;
				height: 88px;
				background-color: $theme-color-main;
				border-radius: 43px;
				font-size: 36px;
				color: #fff;
				display: flex;
				justify-content: center;
				align-items: center;
				margin: 0 auto;
				margin-bottom: 50px;
			}

			.noticetext {
				font-size: 26px;
				width: 619px;
				height: 305px;
				line-height: 40px;
				margin: 0 auto;

				p {
					color: #353535;
					padding: 0;
				}

				span {
					color: #AFAFAF;
				}
			}
		}
	}



</style>
